import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden'
  },
  table: {
    width: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]:{
      overflowX: 'scroll',
      behavior: 'smooth' ,
      display: 'block',
      width: '100%',
    }
  },
  tableCell: {
    fontSize: '13px',
    border: 'none',
    color: '#000000',
    padding: 0
  },
  heading: {
    color: '#071B27',
    fontWeight: 'bold',
    fontSize: '10px',
    fontFamily: 'Fira Sans',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  },
  referenceCell: {
    width: '120px',
    paddingLeft: '20px',
    paddingRight: '40px'
  },
  unitCell: {
    alignItems: 'center',
    width: '470px',
    wordWrap: 'break-word',
    paddingRight: '10px'
  },
  unitContent: {
    display: 'flex',
    alignItems: 'center'
  },
  unitIcon: {
    fill: '#0E8BB4',
    display: 'inline',
    verticalAlign: 'bottom',
    marginRight: '10px'
  },
  title: {
    display: 'inline'
  },
  platformCell: {
    width: '96px',
    paddingLeft: '43px'
  },
  nameCell: {
    width: '155px',
    paddingRight: '80px',
    fontWeight: 'bold'
  },
  guestsCell: {
    alignItems: 'center',
    width: '255px',
    paddingLeft: '30px'
  },
  cellText: {
    display: 'flex',
    alignItems: 'center',
    height: '48px',
    marginRight: '10px'
  },
  list: {
    padding: '10px',
    margin: '0',
    fontSize: '10px',
    color: '#FFFFFF'
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E2F5F8'
    }
  },
  disabledArea: {
    position: 'relative',
    '&::after': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      background: 'black',
      opacity: 0.2
    }
  }
}));

export default useStyles;
